import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function OmOs() {
  return (
    <div className="bg-brand-navy-50 min-h-screen">
      <SEO
        title="Om Entreprenør Jan Nørgaard | 20+ års erfaring"
        description="Læs om Entreprenør Jan Nørgaard ApS. Autoriseret kloakmester og entreprenør med over 20 års erfaring i Sommersted, Haderslev og omegn. Læs mere her."
        image="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=85,format=auto/assets/af349c16-3f04-4dd3-a862-642e24736c63/jan-norgaard-entreprenor.jpg"
      />
      {/* Main Content */}
      <section className="py-16 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 items-center">
          {/* Left Column: Text */}
          <div className="space-y-6">
            <h2 className="font-display text-3xl font-bold uppercase text-brand-navy-900">
              Mange års erfaring som entreprenør
            </h2>
            <p className="text-brand-navy-600 leading-relaxed">
              <Link
                to="/"
                className="font-bold text-brand-navy-900 underline decoration-brand-orange-500 decoration-2 underline-offset-4 hover:text-brand-orange-600 transition-colors"
                title="Entreprenør Jan Nørgaard - Til forsiden"
              >
                Entreprenør Jan Nørgaard ApS
              </Link>{' '}
              blev stiftet med en klar vision: At levere entreprenør- og kloakmesterarbejde af højeste faglige kvalitet, hvor kunden altid kan regne med en ærlig dialog og overholdte aftaler.
            </p>
            <p className="text-brand-navy-600 leading-relaxed">
              Som autoriseret kloakmester har vi den nødvendige teoretiske og praktiske ballast til at løse selv de mest komplekse kloakopgaver. Vi holder os løbende opdateret med de nyeste regler og teknologier på området, så vi altid kan tilbyde de mest fremtidssikre løsninger.
            </p>
            <p className="text-brand-navy-600 leading-relaxed">
              Vi holder til i Sommersted, men løser opgaver i hele lokalområdet og opland, herunder Jels, Vojens, Haderslev, Vejen og Kolding. Vores lokale forankring betyder, at vi hurtigt kan rykke ud, når der er brug for det.
            </p>
            <div className="pt-4">
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 rounded bg-brand-orange-500 px-6 py-3 font-display text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-brand-orange-600"
              >
                Kontakt os i dag <i className="fa-regular fa-arrow-right" />
              </Link>
            </div>
          </div>

          {/* Right Column: Image & Stats */}
          <div className="relative">
            <figure>
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/af349c16-3f04-4dd3-a862-642e24736c63/stoebearbejde-fundament-og-kloak.jpg"
                alt="Færdigstøbt betonfundament og sokkel med kloakrør og sandpude"
                title="Fundament og støbearbejde udført af Entreprenør Jan Nørgaard ApS"
                className="rounded-lg shadow-xl border border-brand-navy-800/10 w-full"
              />
              <figcaption className="mt-2 text-xs text-brand-navy-500 italic">
                Støbning af bærende sokkel og fundament udført af Jan Nørgaards mandskab.
              </figcaption>
            </figure>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="bg-brand-navy-100 text-brand-navy-900 py-16 border-t border-brand-navy-200">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="font-display text-3xl font-bold uppercase text-brand-navy-900">
              Vores tre grundpiller
            </h2>
          </div>

          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            {/* Value 1 */}
            <div className="text-center p-4">
              <div className="mx-auto flex h-14 w-14 items-center justify-center text-brand-navy-900 mb-4">
                <i className="fa-duotone fa-shield-check text-3xl" />
              </div>
              <h3 className="font-display text-xl font-bold uppercase text-brand-navy-900 mb-3">
                Pålidelighed
              </h3>
              <p className="text-sm text-brand-navy-600 leading-relaxed">
                En aftale er en aftale. We møder op til tiden, overholder budgettet og leverer det aftalte arbejde uden ubehagelige overraskelser.
              </p>
            </div>

            {/* Value 2 */}
            <div className="text-center p-4">
              <div className="mx-auto flex h-14 w-14 items-center justify-center text-brand-navy-900 mb-4">
                <i className="fa-duotone fa-award text-3xl" />
              </div>
              <h3 className="font-display text-xl font-bold uppercase text-brand-navy-900 mb-3">
                Faglig Stolthed
              </h3>
              <p className="text-sm text-brand-navy-600 leading-relaxed">
                Vi går aldrig på kompromis med kvaliteten af vores arbejde. Alt udføres efter de højeste faglige standarder og gældende lovgivning.
              </p>
            </div>

            {/* Value 3 */}
            <div className="text-center p-4">
              <div className="mx-auto flex h-14 w-14 items-center justify-center text-brand-navy-900 mb-4">
                <i className="fa-duotone fa-comments text-3xl" />
              </div>
              <h3 className="font-display text-xl font-bold uppercase text-brand-navy-900 mb-3">
                Gennemsigtighed
              </h3>
              <p className="text-sm text-brand-navy-600 leading-relaxed">
                Vi rådgiver ærligt og gennemskueligt. Du får altid et skriftligt tilbud med en klar specifikation af, hvad der er inkluderet.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team/Owner Section */}
      <section className="py-16 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg p-8 md:p-12 shadow-md border border-brand-navy-100 grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          <div className="md:col-span-1">
            <div className="aspect-square rounded-lg overflow-hidden bg-brand-navy-100 border border-brand-navy-200">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=400,height=400,fit=cover,quality=80,format=auto/assets/af349c16-3f04-4dd3-a862-642e24736c63/jan-norgaard-entreprenor.jpg"
                alt="Jan Nørgaard - Ejer og autoriseret kloakmester hos Entreprenør Jan Nørgaard ApS"
                title="Jan Nørgaard - Autoriseret Kloakmester & Entreprenør"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
          <div className="md:col-span-2 space-y-4">
            <span className="text-xs font-bold uppercase tracking-widest text-brand-orange-600">
              Ejer & Direktør
            </span>
            <h3 className="font-display text-2xl font-bold text-brand-navy-900">
              Jan Nørgaard
            </h3>
            <p className="text-sm text-brand-navy-500 font-semibold uppercase tracking-wider">
              Autoriseret Kloakmester & Entreprenør
            </p>
            <p className="text-brand-navy-600 leading-relaxed">
              "Jeg har arbejdet i entreprenørbranchen i mange år, og for mig er det vigtigste, at kunden er fuldt ud tilfreds, når vi kører fra pladsen. Vi sætter en ære i at rydde pænt op efter os, og vi afleverer altid et stykke arbejde, som vi selv kan være stolte af."
            </p>
            <div className="pt-4 flex gap-4">
              <a
                href="tel:+4520483818"
                className="inline-flex items-center gap-2 rounded bg-brand-orange-500 px-5 py-2.5 font-display text-xs font-bold uppercase tracking-wider text-white transition-colors hover:bg-brand-orange-600"
              >
                <i className="fa-solid fa-phone" /> Ring til Jan: 20 48 38 18
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
